/* sp-nav2-veredelung.js – Panel „Veredelung“ (Canvas Board 250): Umschalter Musterbuch · Technik-Finder, Finder-Regeln,
   Hervorhebung im Musterbuch, mobil Tabs ↔ Wisch-Karussell und aufklappbarer Finder. Markup: snippets/sp-nav2-veredelung.liquid
   Regeln (nur belegte Fakten, Board 250): Polo/Cap, Hoodie/Jacke → Stick · Foto/Verlauf, bunt & detailreich, kleine Menge → Digitaldruck ·
   Tasche, Serie/Teamkleidung → Siebdruck · Schrift/wenige Farben → Stick und Siebdruck · T-Shirt → Druck (Digital- und Siebdruck).
   Gleichstand: Textil (Frage 1) entscheidet, dann Menge (Frage 3). Widerspruch (Foto/bunt auf Polo/Cap oder Hoodie/Jacke) → „Zwei Techniken passen“. */
(function () {
  'use strict';
  if (window.__spvInit) return;
  window.__spvInit = true;

  var TECHS = ['digi', 'stick', 'sieb'];
  var RULES = {
    1: { tshirt: { digi: .5, sieb: .5 }, polo: { stick: 1 }, hoodie: { stick: 1 }, tasche: { sieb: 1 } },
    2: { foto: { digi: 1 }, bunt: { digi: 1 }, schrift: { stick: 1, sieb: 1 } },
    3: { klein: { digi: 1, sieb: -.5 }, serie: { sieb: 1 }, offen: {} }
  };
  var TIEBREAK = { 1: .02, 2: 0, 3: .01 };

  function answers(root) {
    var a = {};
    root.querySelectorAll('[data-spv-finder] .spv-chip[aria-pressed="true"]').forEach(function (c) {
      a[c.getAttribute('data-spv-q')] = c.getAttribute('data-spv-a');
    });
    return a;
  }

  function evaluate(a) {
    var s = { digi: 0, stick: 0, sieb: 0 };
    [1, 2, 3].forEach(function (q) {
      var r = RULES[q][a[q]] || {};
      Object.keys(r).forEach(function (t) { s[t] += r[t] + (r[t] > 0 ? TIEBREAK[q] : 0); });
    });
    var order = TECHS.slice().sort(function (x, y) { return s[y] - s[x]; });
    var conflict = (a[2] === 'foto' || a[2] === 'bunt') && (a[1] === 'polo' || a[1] === 'hoodie');
    if (conflict) return { tie: ['digi', 'stick'] };
    if (Math.abs(s[order[0]] - s[order[1]]) < .005) return { tie: [order[0], order[1]] };
    var alt = s[order[1]] >= 1 ? order[1] : null;
    return { best: order[0], alt: alt };
  }

  function nameOf(root, key) {
    var n = root.querySelector('[data-spv-name="' + key + '"] span');
    return n ? n.textContent.trim() : key;
  }

  function setFlag(card, txt, also) {
    var f = card.querySelector('[data-spv-flag]');
    if (!f) return;
    f.textContent = txt || '';
    f.hidden = !txt;
    f.classList.toggle('is-also', !!also);
  }

  function clearResult(root) {
    var grid = root.querySelector('.spv-grid');
    if (grid) grid.classList.remove('has-result');
    root.querySelectorAll('[data-spv-card]').forEach(function (c) {
      c.classList.remove('is-best', 'is-also');
      setFlag(c, '');
    });
    root.querySelectorAll('[data-spv-res]').forEach(function (r) { r.hidden = true; });
    var wrap = root.querySelector('[data-spv-res-wrap]');
    if (wrap) wrap.classList.remove('has-result');
    var alt = root.querySelector('[data-spv-alt]'); if (alt) alt.hidden = true;
    var up = root.querySelector('[data-spv-res-up]'); if (up) up.hidden = true;
    var sub = root.querySelector('[data-spv-fsub]');
    if (sub && sub.dataset.orig) sub.textContent = sub.dataset.orig;
  }

  function labelOf(root, cls) {
    var el = root.querySelector(cls);
    return el ? el.textContent.trim() : '';
  }

  function update(root, fromClick) {
    var a = answers(root);
    var n = Object.keys(a).length;
    root.querySelectorAll('[data-spv-prog]').forEach(function (i) {
      i.classList.toggle('is-on', !!a[i.getAttribute('data-spv-prog')]);
    });
    clearResult(root);
    var qs = root.querySelector('[data-spv-qs]'), sum = root.querySelector('[data-spv-sum]');
    if (n < 3) {
      if (qs) qs.hidden = false;
      if (sum) sum.hidden = true;
      return;
    }
    var res = evaluate(a);
    var bestLbl = labelOf(root, '[data-spv-res="digi"] .spv-r__lbl');
    var alsoLbl = (labelOf(root, '.spv-alt__l') || '').replace(/:$/, '');
    // Zusammenfassung der Antworten statt der Fragen
    if (sum) {
      var t = [1, 2, 3].map(function (q) {
        var c = root.querySelector('.spv-chip[data-spv-q="' + q + '"][aria-pressed="true"]');
        return c ? c.textContent.trim() : '';
      }).join(' · ');
      root.querySelector('[data-spv-sumtext]').textContent = t;
      sum.hidden = false;
    }
    if (qs) qs.hidden = true;
    var grid = root.querySelector('.spv-grid');
    if (grid) grid.classList.add('has-result');
    var wrap = root.querySelector('[data-spv-res-wrap]');
    if (wrap) wrap.classList.add('has-result');
    var cards = {};
    root.querySelectorAll('[data-spv-card]').forEach(function (c) { cards[c.getAttribute('data-spv-card')] = c; });
    var focusKey;
    if (res.tie) {
      var tie = root.querySelector('[data-spv-res="tie"]');
      if (tie) {
        tie.querySelector('[data-spv-tienames]').textContent = res.tie.map(function (k) { return nameOf(root, k); }).join(' + ');
        tie.hidden = false;
      }
      var tieLbl = labelOf(root, '[data-spv-res="tie"] .spv-r__lbl');
      res.tie.forEach(function (k) { if (cards[k]) { cards[k].classList.add('is-best'); setFlag(cards[k], tieLbl); } });
      focusKey = res.tie[0];
    } else {
      var box = root.querySelector('[data-spv-res="' + res.best + '"]');
      if (box) {
        box.querySelectorAll('[data-spv-if]').forEach(function (li) {
          var c = li.getAttribute('data-spv-if').split(':');
          li.hidden = a[c[0]] !== c[1];
        });
        box.hidden = false;
      }
      if (cards[res.best]) { cards[res.best].classList.add('is-best'); setFlag(cards[res.best], bestLbl); }
      if (res.alt) {
        var alt = root.querySelector('[data-spv-alt]'), src = root.querySelector('[data-spv-alt-src="' + res.alt + '"]');
        if (alt && src) {
          var l = alt.querySelector('[data-spv-alt-link]');
          l.textContent = src.textContent; l.href = src.getAttribute('data-href');
          alt.hidden = false;
        }
        if (cards[res.alt]) { cards[res.alt].classList.add('is-also'); setFlag(cards[res.alt], alsoLbl, true); }
      }
      var up = root.querySelector('[data-spv-res-up]'); if (up) up.hidden = false;
      focusKey = res.best;
    }
    var sub = root.querySelector('[data-spv-fsub]');
    if (sub) {
      if (!sub.dataset.orig) sub.dataset.orig = sub.textContent;
      sub.textContent = (res.tie ? res.tie.map(function (k) { return nameOf(root, k); }).join(' + ') : nameOf(root, res.best));
    }
    // Mobil: passendes Muster ins Karussell holen
    if (fromClick && root.querySelector('[data-spv-car]')) scrollToCard(root, focusKey);
  }

  function setMode(root, mode) {
    root.setAttribute('data-spv-mode', mode);
    root.querySelectorAll('[data-spv-mode-btn]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-spv-mode-btn') === mode ? 'true' : 'false');
    });
    root.querySelectorAll('[data-spv-show]').forEach(function (el) { el.hidden = el.getAttribute('data-spv-show') !== mode; });
    root.querySelectorAll('[data-spv-pane]').forEach(function (el) { el.hidden = el.getAttribute('data-spv-pane') !== mode; });
    if (mode === 'buch') clearResult(root); else update(root, false);
  }

  /* ---------- Mobil: Tabs ↔ Karussell ---------- */
  function scrollToCard(root, key) {
    var car = root.querySelector('[data-spv-car]');
    var card = car && car.querySelector('[data-spv-card="' + key + '"]');
    if (!card) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    car.scrollTo({ left: Math.max(0, card.offsetLeft - 16), behavior: reduce ? 'auto' : 'smooth' });
    setTab(root, key);
  }
  function setTab(root, key) {
    root.querySelectorAll('[data-spv-tab]').forEach(function (t) {
      t.setAttribute('aria-pressed', t.getAttribute('data-spv-tab') === key ? 'true' : 'false');
    });
  }
  function bindCarousel(car) {
    if (car.dataset.spvBound) return;
    car.dataset.spvBound = '1';
    var root = car.closest('[data-spv]'), raf = 0;
    car.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var best = null, dist = Infinity, x = car.scrollLeft;
        car.querySelectorAll('[data-spv-card]').forEach(function (c) {
          var d = Math.abs((c.offsetLeft - 16) - x);
          if (d < dist) { dist = d; best = c; }
        });
        if (best) setTab(root, best.getAttribute('data-spv-card'));
      });
    }, { passive: true });
  }

  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-spv]');
    if (!root) return;
    var b;
    if ((b = e.target.closest('[data-spv-mode-btn]'))) { e.preventDefault(); setMode(root, b.getAttribute('data-spv-mode-btn')); return; }
    if ((b = e.target.closest('[data-spv-go]'))) {
      e.preventDefault();
      setMode(root, b.getAttribute('data-spv-go'));
      var first = root.querySelector('[data-spv-pane="finder"] .spv-chip');
      if (first) first.focus();
      return;
    }
    if ((b = e.target.closest('.spv-chip[data-spv-q]'))) {
      e.preventDefault();
      var q = b.getAttribute('data-spv-q');
      root.querySelectorAll('.spv-chip[data-spv-q="' + q + '"]').forEach(function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
      update(root, true);
      if (Object.keys(answers(root)).length === 3) {
        var edit = root.querySelector('[data-spv-edit]');
        if (edit) edit.focus({ preventScroll: true });
      }
      return;
    }
    if ((b = e.target.closest('[data-spv-reset]'))) {
      e.preventDefault();
      root.querySelectorAll('.spv-chip[data-spv-q]').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      update(root, false);
      var f1 = root.querySelector('.spv-chip[data-spv-q="1"]'); if (f1) f1.focus();
      return;
    }
    if ((b = e.target.closest('[data-spv-edit]'))) {
      e.preventDefault();
      var qs = root.querySelector('[data-spv-qs]'), sum = root.querySelector('[data-spv-sum]');
      if (qs) qs.hidden = false;
      if (sum) sum.hidden = true;
      var p1 = root.querySelector('.spv-chip[data-spv-q="1"][aria-pressed="true"]'); if (p1) p1.focus();
      return;
    }
    if ((b = e.target.closest('[data-spv-tab]'))) { e.preventDefault(); scrollToCard(root, b.getAttribute('data-spv-tab')); return; }
    if ((b = e.target.closest('[data-spv-ftoggle]'))) {
      e.preventDefault();
      var open = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      var body = document.getElementById(b.getAttribute('aria-controls'));
      if (body) body.hidden = !open;
      return;
    }
  });

  function boot() { document.querySelectorAll('[data-spv-car]').forEach(bindCarousel); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  // Drawer-Inhalte können später eingefügt werden: Karussell beim ersten Wischen binden
  document.addEventListener('touchstart', function (e) {
    var car = e.target.closest && e.target.closest('[data-spv-car]');
    if (car) bindCarousel(car);
  }, { passive: true });
})();